import React from "react";
import PropTypes from "prop-types";
import { InviteUserForm } from "components/settings/invite-user-form";
import { Modal } from "components/common/modal";

export const InviteUserModal = ({
  isInviteUserVisible,
  onCreateUser,
  onHideInviteUser
}) => (
  <Modal
    isVisible={ isInviteUserVisible }
    onClose={ onHideInviteUser }
    transitionName="invite-user"
  >
    <h2>Invite User</h2>
    <InviteUserForm onCreateUser={ onCreateUser } onHideInviteUser={ onHideInviteUser } />
  </Modal>
);

InviteUserModal.defaultProps = {
  newUser: null
};

InviteUserModal.propTypes = {
  isInviteUserVisible: PropTypes.bool.isRequired,
  onCreateUser: PropTypes.func.isRequired,
  onHideInviteUser: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/settings/invite-user-modal.jsx